/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const CHECK = 'CHECK';
export const REGISTER = 'REGISTER';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export default {
    CHECK,
    REGISTER,
    LOGIN,
    LOGOUT,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutation-types.js